import type { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { List } from '@material-ui/core';

interface PropertyListProps {
  children: ReactNode;
  sx?: any;
}

export const PropertyList: FC<PropertyListProps> = (props) => {
  const { children, sx } = props;

  return (
    <List disablePadding sx={sx}>
      {children}
    </List>
  );
};

PropertyList.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};
